import DirectCallLandingView from "../components/landing/directCall/DirectCallLandingView";

const LandingDirectCall3 = () => (
  <DirectCallLandingView
    landingName="landing-direct-call-3"
    phoneDisplay="02 4074 1133"
    phoneTel="tel:+390240741133"
  />
);

export default LandingDirectCall3;
